'use client'

import type { MediaGalleryFieldsFragment } from '@/graphql/types'
import { useContentfulEntryLivePreview } from '@/components/providers/useContentfulEntryLivePreview'
import { DynamicMediaGallery } from '@ccpgames/eve-web-core'
import { mapMediaBlocksToItems } from '../utils'
import { buildContentfulInspectorProps } from '@/components/providers/contentfulInspectorProps'

interface MediaGalleryRowsProps {
  entry: MediaGalleryFieldsFragment
}

/**
 * Rows view: Displays media items in horizontal rows
 * Each item is displayed using the MediaBlock component with alternating flipped layout
 */
export function MediaGalleryRows({ entry }: MediaGalleryRowsProps) {
  const { updatedEntry, inspectorProps } = useContentfulEntryLivePreview(entry)

  const view = 'rows' as const

  const imageOptions = { view, objectFit: 'contain' as const, fill: false }
  const items = mapMediaBlocksToItems(updatedEntry.contentCollection, {
    ...imageOptions,
    getItemSectionInspectorProps: (mediaBlock) => buildContentfulInspectorProps(mediaBlock.sys.id, 'media'),
  })

  if (items.length === 0) {
    return null
  }

  return (
    <DynamicMediaGallery
      view={view}
      title={updatedEntry.title ?? undefined}
      content={updatedEntry.subtitle ?? undefined}
      items={items}
      sectionInspectorProps={inspectorProps('contentCollection')}
    />
  )
}
